module.exports = __webpack_public_path__ + "static/media/dollar-2-underwood.f65c859d.png";